module.exports = __webpack_public_path__ + "d93f23fe19082a8735cbaba9b0a4c3e4.svg";